import { computed } from "vue";
import useCreateComponentConfig from "../../../../composables/useCreateComponentConfig.js";
import { SIZES } from "@/ui/ts/types/Sizes";
var EStepperSeperatorElements = /* @__PURE__ */ ((EStepperSeperatorElements2) => {
  EStepperSeperatorElements2["ROOT"] = "root";
  return EStepperSeperatorElements2;
})(EStepperSeperatorElements || {});
export function useStepperIndicatorConfig(props) {
  const { rootClasses } = useRootConfig(props);
  return {
    root: rootClasses
  };
}
function useRootConfig(props) {
  const { setBase, addSize, getClasses } = useCreateComponentConfig();
  setBase(
    "root" /* ROOT */,
    "border-brand-accent-invert inline-flex items-center justify-center rounded-full text-brand-accent-invert shrink-0 group-data-[state=active]:bg-brand-accent-invert group-data-[state=active]:text-brand-accent group-data-[state=completed]:bg-brand-accent-invert group-data-[state=completed]:text-brand-accent"
  );
  addSize(
    "root" /* ROOT */,
    SIZES.SMALL,
    /* tw */
    "size-base border-thin"
  );
  addSize(
    "root" /* ROOT */,
    SIZES.MEDIUM,
    /* tw */
    "size-xl border"
  );
  const rootClasses = computed(() => getClasses("root" /* ROOT */, void 0, props.size));
  return {
    rootClasses: rootClasses.value
  };
}
